import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServicesOverview from "./sections/OurServicesOverview";
import FleetShowcase from "./sections/FleetShowcase";
import ClientTestimonials from "./sections/ClientTestimonials";
import WhyChooseUs from "./sections/WhyChooseUs";
import QuickReservationCallToAction from "./sections/QuickReservationCallToAction";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServicesOverview />
      <FleetShowcase />
      <ClientTestimonials />
      <WhyChooseUs />
      <Booking />
      <QuickReservationCallToAction />
      <Footer />
    </div>;
}